import React from "react";
import ColorPicker from "../ColorPicker";
import classnames from "classnames";
import { STATE_KEYS } from "utils/constants/state";
import { TRANSFORM_DARKEN } from "utils/theme";

const COLOR_CONFIG = [
  {
    label: "Brand",
    colors: [
      {
        label: "Primary",
        name: STATE_KEYS.THEME.COLOR_SECONDARY,
        effect: {
          name: STATE_KEYS.THEME.COLOR_PRIMARY,
          transform: TRANSFORM_DARKEN
        }
      },
      {
        label: "Highlight",
        name: STATE_KEYS.THEME.COLOR_HIGHLIGHT
      }
    ]
  },
  {
    label: "Text",
    colors: [
      {
        label: "Primary",
        name: STATE_KEYS.THEME.TEXT_PRIMARY
      },
      {
        label: "Secondary",
        name: STATE_KEYS.THEME.TEXT_SECONDARY
      }
    ]
  }
];

const ThemeColorPickers = () =>
  COLOR_CONFIG.map(({ label, colors }, groupIx) => {
    return (
      <div key={groupIx} className="w-100">
        <div className={classnames("f5 ph3 fw5 pt3 pb2")}>{label}</div>
        {colors.map((colorConfig, colorConfigIx) => {
          return (
            <div
              key={colorConfigIx}
              className={classnames("w-100 bb hairline-1")}
            >
              <ColorPicker {...colorConfig} />
            </div>
          );
        })}
      </div>
    );
  });

export default ThemeColorPickers;
